import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '../views/MainLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/AdminLayout.vue'),
    redirect: '/admin/overview',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'stations',
        name: 'StationManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/StationManage.vue')
      },
      {
        path: 'data',
        name: 'DataManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/DataManage.vue')
      },
      {
        path: 'overview',
        name: 'DataOverview',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/DataOverview.vue')
      },
      {
        path: 'users',
        name: 'UserManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/UserManage.vue')
      },
      {
        path: 'turbines',
        name: 'WindTurbineManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/WindTurbineManage.vue')
      },
      {
        path: 'solar-panels',
        name: 'SolarPanelManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/SolarPanelManage.vue')
      }
    ]
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/wind',
    children: [
      {
        path: 'wind',
        name: 'WindHome',
        component: () => import(/* webpackChunkName: "WindHome" */ '../views/WindHome.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'solar',
        name: 'SolarHome',
        component: () => import(/* webpackChunkName: "SolarHome" */ '../views/SolarHome.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 登录验证
router.beforeEach((to, from, next) => {
  const isLoggedIn = sessionStorage.getItem('isLoggedIn')
  if (to.path === '/login') {
    // 已登录则跳转首页
    if (isLoggedIn) {
      next('/wind')
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要登录的页面，未登录则跳转登录页
    if (!isLoggedIn) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
